module.exports = __webpack_public_path__ + "media/tick-tock-clock-timer-1048-2.1464aec2.wav";